export const APISERVERURL='https://api.cottonapp.nirupan.org'
